// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236C766F%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nurturer-marketing {
  --bg: #F4F2EB;
  --surface: #FFFFFF;
  --surface-alt: #FAF8F2;
  --teal: #23C2C4;
  --teal-deep: #0C8587;
  --teal-deeper: #0A6F71;
  --primary: #0C8587;
  --primary-soft: #DEF3F3;
  --accent: #DD9F3C;
  --accent-soft: #F8ECD3;
  --cream: #F3ECC4;
  --ink: #1B241F;
  --ink-70: rgba(27, 36, 31, 0.72);
  --muted: #6C766F;
  --faint: #9AA29B;
  --border: rgba(28, 40, 33, 0.10);
  --border-strong: rgba(28, 40, 33, 0.16);
  --on-teal: #FFFFFF;
  --on-teal-70: rgba(255, 255, 255, 0.80);
  --shadow: 0 1px 2px rgba(20, 30, 24, 0.04), 0 10px 30px -18px rgba(20, 30, 24, 0.22);
  --shadow-lg: 0 30px 70px -32px rgba(20, 30, 24, 0.40), 0 4px 10px rgba(20, 30, 24, 0.06);
  --sans: 'DM Sans', system-ui, -apple-system, sans-serif;
  --serif: 'Newsreader', Georgia, serif;
  --mono: 'JetBrains Mono', ui-monospace, monospace;

  background: var(--bg);
  color: var(--ink);
  font-family: var(--sans);
  -webkit-font-smoothing: antialiased;
  scroll-behavior: smooth;
}

.nurturer-marketing *,
.nurturer-marketing *::before,
.nurturer-marketing *::after {
  box-sizing: border-box;
}

.nurturer-marketing a {
  color: inherit;
  text-decoration: none;
}

.nurturer-marketing .wrap {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 40px;
}

.nurturer-marketing .eyebrow {
  font-family: var(--mono);
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.nurturer-marketing .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  font-family: var(--sans);
  font-weight: 600;
  font-size: 15px;
  padding: 13px 24px;
  border-radius: 12px;
  border: 1px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.08s ease, box-shadow 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.nurturer-marketing .btn:active {
  transform: translateY(1px);
}

.nurturer-marketing .btn-cream {
  background: var(--cream);
  color: var(--ink);
  box-shadow: 0 8px 24px -12px rgba(243, 236, 196, 0.9);
}

.nurturer-marketing .btn-cream:hover {
  background: #F7F1D2;
}

.nurturer-marketing .btn-ghost {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.55);
}

.nurturer-marketing .btn-ghost:hover {
  background: rgba(255, 255, 255, 0.16);
}

.nurturer-marketing .btn-primary {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 10px 28px -14px rgba(12, 133, 135, 0.8);
}

.nurturer-marketing .btn-primary:hover {
  background: var(--teal-deeper);
}

.nurturer-marketing .hero {
  position: relative;
  overflow: hidden;
  color: var(--on-teal);
  background:
    radial-gradient(1100px 520px at 82% -8%, rgba(243, 236, 196, 0.30), transparent 58%),
    radial-gradient(900px 600px at 8% 120%, rgba(255, 255, 255, 0.12), transparent 60%),
    linear-gradient(135deg, #1FB3B5 0%, #23C2C4 42%, #0C8587 100%);
}

.nurturer-marketing .hero--compact {
  background:
    radial-gradient(1100px 480px at 82% -20%, rgba(243, 236, 196, 0.30), transparent 58%),
    linear-gradient(135deg, #1FB3B5 0%, #23C2C4 42%, #0C8587 100%);
}

.nurturer-marketing nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 26px 0;
}

.nurturer-marketing .brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nurturer-marketing .brand .mark {
  width: 42px;
  height: 42px;
}

.nurturer-marketing .brand .name {
  font-weight: 700;
  font-size: 21px;
  letter-spacing: -0.3px;
  color: #fff;
}

.nurturer-marketing .navlinks {
  display: flex;
  align-items: center;
  gap: 30px;
}

.nurturer-marketing .navlinks a {
  font-size: 15px;
  color: var(--on-teal-70);
  font-weight: 500;
  transition: color 0.15s;
}

.nurturer-marketing .navlinks a:hover,
.nurturer-marketing .navlinks a.active {
  color: #fff;
}

.nurturer-marketing .nav-login {
  padding: 9px 18px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  color: #fff !important;
  white-space: nowrap;
}

.nurturer-marketing .nav-login:hover {
  background: rgba(255, 255, 255, 0.12);
}

.nurturer-marketing .hero-inner {
  text-align: center;
  padding: 78px 0 122px;
  max-width: 860px;
  margin: 0 auto;
}

.nurturer-marketing .hero--compact .hero-inner {
  text-align: left;
  padding: 56px 0 78px;
  max-width: 720px;
}

.nurturer-marketing .hero h1 {
  font-family: var(--sans);
  font-weight: 700;
  font-size: clamp(40px, 6vw, 76px);
  line-height: 1.02;
  letter-spacing: -2px;
  margin: 22px 0 0;
}

.nurturer-marketing .hero--compact h1 {
  font-size: clamp(38px, 5vw, 60px);
  line-height: 1.04;
  letter-spacing: -1.6px;
  margin: 18px 0 0;
}

.nurturer-marketing .hero h1 em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  color: var(--cream);
  letter-spacing: -1px;
}

.nurturer-marketing .hero p.lede {
  font-size: 19px;
  line-height: 1.6;
  color: var(--on-teal-70);
  max-width: 620px;
  margin: 26px auto 0;
}

.nurturer-marketing .hero--compact p.lede {
  font-size: 18px;
  max-width: 540px;
  margin: 20px 0 0;
}

.nurturer-marketing .hero .cta {
  display: flex;
  gap: 14px;
  justify-content: center;
  margin-top: 38px;
}

.nurturer-marketing .scrollcue {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.6);
  font-family: var(--mono);
  font-size: 11px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.nurturer-marketing .scrollcue svg {
  animation: nurturer-bob 1.8s ease-in-out infinite;
}

@keyframes nurturer-bob {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(5px); }
}

.nurturer-marketing section.block {
  padding: 104px 0;
}

.nurturer-marketing .sec-head {
  text-align: center;
  margin-bottom: 64px;
}

.nurturer-marketing .sec-head h2 {
  font-family: var(--sans);
  font-weight: 700;
  font-size: 34px;
  letter-spacing: -0.6px;
  margin: 0;
  color: var(--ink);
}

.nurturer-marketing .sec-head .rule {
  width: 64px;
  height: 3px;
  border-radius: 99px;
  background: var(--accent);
  margin: 16px auto 0;
}

.nurturer-marketing .split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 72px;
  align-items: center;
}

.nurturer-marketing .split + .split {
  margin-top: 110px;
}

.nurturer-marketing .copy .kicker {
  color: var(--primary);
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  margin-bottom: 14px;
  font-family: var(--sans);
}

.nurturer-marketing .copy h3 {
  font-family: var(--sans);
  font-weight: 700;
  font-size: 30px;
  line-height: 1.15;
  letter-spacing: -0.5px;
  margin: 0 0 18px;
  color: var(--ink);
}

.nurturer-marketing .copy h3 .accent {
  color: var(--primary);
}

.nurturer-marketing .copy p {
  font-size: 16.5px;
  line-height: 1.7;
  color: var(--ink-70);
  margin: 0 0 16px;
}

.nurturer-marketing .copy .mini {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  font-weight: 600;
  color: var(--primary);
  font-size: 15px;
}

.nurturer-marketing .warmthcard {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 26px 26px 20px;
  box-shadow: var(--shadow);
}

.nurturer-marketing .warmthcard .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.nurturer-marketing .warmthcard .top .t {
  font-weight: 700;
  font-size: 15px;
  color: var(--ink);
}

.nurturer-marketing .warmthcard .top .lg {
  font-family: var(--mono);
  font-size: 10.5px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--faint);
}

.nurturer-marketing .warmthcard svg {
  width: 100%;
  height: auto;
  display: block;
}

.nurturer-marketing .problem {
  background: var(--bg);
}

.nurturer-marketing .solution {
  background: var(--surface-alt);
}

.nurturer-marketing .device {
  width: 100%;
  max-width: 580px;
  margin: 0 auto;
}

.nurturer-marketing .device .lid {
  background: linear-gradient(#1b2a25, #11201b);
  padding: 12px;
  border-radius: 18px;
  box-shadow: var(--shadow-lg);
}

.nurturer-marketing .device .cam {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #38463f;
  margin: 1px auto 9px;
}

.nurturer-marketing .device .scr {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  aspect-ratio: 924 / 540;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.25);
}

.nurturer-marketing .device .scr img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top left;
}

.nurturer-marketing .device .base {
  position: relative;
  height: 16px;
  width: 114%;
  margin: -2px -7% 0;
  background: linear-gradient(#d4d8d6, #a7afac);
  border-radius: 0 0 16px 16px;
  box-shadow: 0 14px 24px -14px rgba(20, 30, 24, 0.4);
}

.nurturer-marketing .device .base::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 110px;
  height: 7px;
  background: #828d8a;
  border-radius: 0 0 9px 9px;
}

.nurturer-marketing footer {
  background: linear-gradient(135deg, #23C2C4, #0C8587);
  color: #fff;
}

.nurturer-marketing .foot-main {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1.4fr;
  gap: 48px;
  padding: 64px 0 40px;
  align-items: start;
}

.nurturer-marketing .foot-brand .name {
  font-weight: 700;
  font-size: 24px;
}

.nurturer-marketing .foot-brand .email {
  color: var(--on-teal-70);
  font-size: 15px;
  margin-top: 6px;
}

.nurturer-marketing .foot-col h4 {
  font-family: var(--mono);
  font-size: 11px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin: 4px 0 16px;
  font-weight: 500;
}

.nurturer-marketing .foot-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 11px;
}

.nurturer-marketing .foot-col ul a {
  color: var(--on-teal-70);
  font-size: 15px;
}

.nurturer-marketing .foot-col ul a:hover {
  color: #fff;
}

.nurturer-marketing .subscribe .lbl {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 14px;
}

.nurturer-marketing .subform {
  display: flex;
  gap: 8px;
}

.nurturer-marketing .subform input {
  flex: 1;
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  border-radius: 10px;
  padding: 12px 14px;
  font-family: var(--sans);
  font-size: 14px;
  outline: none;
}

.nurturer-marketing .subform input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.nurturer-marketing .subform input:focus {
  border-color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.nurturer-marketing .subform button {
  background: var(--cream);
  color: var(--ink);
  border: none;
  border-radius: 10px;
  padding: 0 20px;
  font-family: var(--sans);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}

.nurturer-marketing .foot-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  padding: 20px 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  font-size: 13.5px;
  color: var(--on-teal-70);
  flex-wrap: wrap;
}

.nurturer-marketing .foot-bottom .legal {
  display: flex;
  gap: 26px;
}

.nurturer-marketing .contact-body {
  padding: 72px 0 104px;
}

.nurturer-marketing .grid {
  display: grid;
  grid-template-columns: 1.25fr 0.9fr;
  gap: 40px;
  align-items: start;
}

.nurturer-marketing .card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 20px;
  box-shadow: var(--shadow);
}

.nurturer-marketing .form-card {
  padding: 32px;
}

.nurturer-marketing .form-card h2 {
  font-family: var(--sans);
  font-weight: 700;
  font-size: 22px;
  letter-spacing: -0.4px;
  margin: 0 0 4px;
}

.nurturer-marketing .form-card .sub {
  font-size: 14px;
  color: var(--muted);
  margin-bottom: 22px;
}

.nurturer-marketing .field {
  margin-bottom: 16px;
}

.nurturer-marketing .field.row2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.nurturer-marketing .field.row2 .field {
  margin: 0;
}

.nurturer-marketing label {
  display: block;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ink-70);
  margin-bottom: 7px;
}

.nurturer-marketing .inp {
  width: 100%;
  font-family: var(--sans);
  font-size: 14.5px;
  color: var(--ink);
  background: var(--surface-alt);
  border: 1px solid var(--border);
  border-radius: 11px;
  padding: 12px 14px;
  outline: none;
  transition: border 0.15s, box-shadow 0.15s;
}

.nurturer-marketing .inp::placeholder {
  color: var(--faint);
}

.nurturer-marketing .inp:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-soft);
}

.nurturer-marketing textarea.inp {
  resize: vertical;
  min-height: 124px;
  line-height: 1.5;
}

.nurturer-marketing select.inp {
  -webkit-appearance: none;
          appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 38px;
}

.nurturer-marketing .form-foot {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 6px;
}

.nurturer-marketing .form-foot .note {
  font-size: 12.5px;
  color: var(--faint);
}

.nurturer-marketing .form-foot .btn-primary {
  width: auto;
  padding: 14px 28px;
}

.nurturer-marketing .info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nurturer-marketing .info-card {
  padding: 24px;
}

.nurturer-marketing .info-row {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 14px 0;
  border-bottom: 1px solid var(--border);
}

.nurturer-marketing .info-row:last-child {
  border-bottom: none;
}

.nurturer-marketing .info-ico {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  background: var(--primary-soft);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.nurturer-marketing .info-row .lbl {
  font-family: var(--mono);
  font-size: 10.5px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--faint);
  margin-bottom: 3px;
}

.nurturer-marketing .info-row .val {
  font-size: 15px;
  color: var(--ink);
  font-weight: 500;
  line-height: 1.45;
}

.nurturer-marketing .demo-card {
  padding: 24px;
  background: linear-gradient(135deg, #23C2C4, #0C8587);
  color: #fff;
  border: none;
}

.nurturer-marketing .demo-card h3 {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  font-size: 23px;
  line-height: 1.2;
  margin: 0 0 8px;
}

.nurturer-marketing .demo-card p {
  font-size: 14px;
  color: var(--on-teal-70);
  margin: 0 0 16px;
  line-height: 1.5;
}

.nurturer-marketing .demo-card .btn-cream {
  width: 100%;
}

@media (max-width: 860px) {
  .nurturer-marketing .wrap {
    padding: 0 22px;
  }

  .nurturer-marketing .navlinks {
    gap: 16px;
  }

  .nurturer-marketing .navlinks a:not(.nav-login) {
    display: none;
  }

  .nurturer-marketing .split {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .nurturer-marketing .split.reverse .copy {
    order: 2;
  }

  .nurturer-marketing .split.reverse .device {
    order: 1;
  }

  .nurturer-marketing section.block {
    padding: 72px 0;
  }

  .nurturer-marketing .split + .split {
    margin-top: 72px;
  }

  .nurturer-marketing .foot-main {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .nurturer-marketing .hero-inner {
    padding: 56px 0 92px;
  }

  .nurturer-marketing .grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .nurturer-marketing .form-card {
    padding: 28px;
  }

  .nurturer-marketing .field.row2 {
    grid-template-columns: 1fr;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
